/* <cart-drawer>: the slide-in basket. open(trigger) / close(). Content is re-rendered by cart.js on every
   `cart:update` (only the inner panel #CartDrawer-Content is swapped, so the open state survives).
   Focus is trapped while open; Esc, the close button and the page overlay close it. */
if (!customElements.get('cart-drawer')) {
  customElements.define('cart-drawer', class CartDrawer extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.addEventListener('click', e => {
        if (e.target.closest('[data-cart-drawer-close]')) { this.close(); return; }
        // opening a quick view from the upsell row: get out of the way first
        if (e.target.closest('[data-quick-view]')) this.close(false);
      });
      // Esc is caught on the document: re-rendering the panel can move focus to <body>
      this.onKeydown = e => { if (e.key === 'Escape' && this.isOpen) { e.stopPropagation(); this.close(); } };
      // checkout: show progress, keep the native form submit
      this.addEventListener('submit', e => {
        const button = e.submitter;
        if (button?.name === 'checkout') button.classList.add('is-loading');
      });
      // the theme editor: show the drawer while its section is selected
      document.addEventListener('shopify:section:select', e => { if (e.target.contains(this)) this.open(); });
      document.addEventListener('shopify:section:deselect', e => { if (e.target.contains(this)) this.close(false); });
      // returning with the back button after checkout: drop stale loading states
      window.addEventListener('pageshow', () => this.querySelectorAll('.is-loading').forEach(b => b.classList.remove('is-loading')));
    }

    get isOpen() { return this.opened === true; }

    open(trigger) {
      if (this.isOpen) return;
      this.opened = true;
      this.trigger = trigger || document.activeElement;
      document.addEventListener('keydown', this.onKeydown);
      this.removeAttribute('inert');
      // next frame so the slide-in transition runs after inert is lifted
      requestAnimationFrame(() => this.classList.add('is-open'));
      document.querySelectorAll('[data-cart-open]').forEach(b => b.setAttribute('aria-expanded', 'true'));
      theme.lockScroll();
      theme.showOverlay(() => this.close());
      theme.trapFocus(this, this.querySelector('[data-cart-drawer-close]'));
    }

    close(restoreFocus = true) {
      if (!this.isOpen) return;
      this.opened = false;
      document.removeEventListener('keydown', this.onKeydown);
      this.classList.remove('is-open');
      this.setAttribute('inert', '');
      document.querySelectorAll('[data-cart-open]').forEach(b => b.setAttribute('aria-expanded', 'false'));
      theme.unlockScroll();
      theme.hideOverlay();
      theme.removeTrapFocus(restoreFocus ? this.trigger : null);
    }
  });
}
